/* eslint-disable camelcase */
export default {
  no_metabase: "Отсутсвуют данные Metabase",
};
